export const checkImageSmall = (file, minWidth = 640) => new Promise((resolve) => {
  let _URL = window.URL || window.webkitURL
  let url = _URL.createObjectURL(file)
  const img = new Image()

  img.onload = function () {
    _URL.revokeObjectURL(file)
    if (img.width < minWidth) {
      resolve(true)
    } else {
      resolve(false)
    }
  }
  img.src = url;
})

